<mat-toolbar class="background-color-green" style=" position: sticky; top: 0;  z-index: 7;">            
    <span class="text-color-white">{{ 'ml_151228' | translate }}</span>
    <span class="example-spacer"></span>        
    <a mat-dialog-close>
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a> 
    
</mat-toolbar>

<div *ngIf="showVideo">
    
    <video autoplay muted autopictureinpicture controls height="auto" width="100%">        
        <source [src]="videoUrl" type="video/mp4">
    </video>

    <p style="color: gray; margin-left: 8px; font-size: 18px;">{{ 'ml_151273' | translate }}</p>
</div>



